import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DashboardService } from "./dashboard.service";
import { TimelineService } from "../../_services/timeline.service";
import { appService } from "../../../app/_services/app.service";
import { ToastrService } from "ngx-toastr";
import { DetailsComponent } from "./details/details.component";
import { ListTemplate } from "@amcharts/amcharts4/core";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { Console } from "@angular/core/src/console";
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;
declare var google: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  selectedLang: string;
  static dashboardComponent: DashboardComponent;
  @ViewChild(DetailsComponent) DetailComp: DetailsComponent;
  show = true;
  ID: any;
  CompanyId: any;
  comapnyname: any;
  fcnumber: any;
  OrderByidList: any = [];
  selected = "Origin Pending Assign Vehicle";
  arrow = true;
  param1: any;
  icon: {
    url: "../../../assets/img/truck.png";
    scaledSize: { width: 50; height: 60 };
  };
  search: string = "";
  display = "list"; // to hide & show list & details
  select = "Origin Pending Assign Vehicle"; //for dropdown
  ListType = "O"; //O=Origin and D=Destination (If Destination pass than pull data  by consignment note)
  CustomerId: any;
  public origin: any;
  public destination: any;
  dir: {
    origin: { lat: number; lng: number };
    destination: { lat: number; lng: number };
  };
  ConsignmentDetailId: any;
  // MapIcon: {
  //   url: "";
  //   scaledSize: { width: 50; height: 60 };
  // };

  // add kevin 08/09/2020
  eWayBillFlag: boolean = true;
  THCFlag: boolean = true;
  DriverInfo: any = [];
  mob;
  fname;
  lname;
  vNo;
  // end
  //add kevin 14/06/2021
  isFreightExport: any;
  //end

  constructor(
    public service: DashboardService,
    private _appService: appService,
    private toastr: ToastrService,
    private chatservice: TimelineService,
    private service1: TranslateConfigService,
    private translate: TranslateService
  ) {
    DashboardComponent.dashboardComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service1.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.translate.get(["DASHBOARDMAIN.opav"]).subscribe((translations) => {
      this.select = translations["DASHBOARDMAIN.opav"];
    });
    console.log("main", this.select);
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.service.changePage.subscribe((e) => {
      this.display = e;
    });
    //Changed by pawan on 11-2-2020
    // add kevin 08/09/2020
    this.eWayBillFlag = JSON.parse(localStorage.getItem("eWayBillFlag"));
    this.THCFlag = JSON.parse(localStorage.getItem("THCFlag"));
    this.isFreightExport = JSON.parse(localStorage.getItem("isFreightExport"));
    // end
  }

  onMarkerClick(mobile) {
    this._appService.GetByDriver("DriverMobileOrders" , "GetDriversInfo" , mobile).subscribe((res) => {
      this.DriverInfo = res as any;
      this.fname = this.DriverInfo[0].FirstName;
      this.lname = this.DriverInfo[0].LastName;
      this.mob = this.DriverInfo[0].MobileNo;
      this.vNo = this.DriverInfo[0].VehicleNo;
      $("#myModal").modal('show');
    });
  }

  onClick() {
    this.arrow = !this.arrow;
    this.show = !this.show;
  }

  onSelect(status) {
    this.selected = status;
    this.select = status;
  }

  //Here Getting Id's as parameters from Dashboard.component.html and assigning here -- Modified by Pawan Darji on 18-feb
  onDisplay(a, Id, ListType, CustomerId, ConsignmentDetailId, FCNumber) {
    this.ID = Id;
    this.display = a;
    this.ListType = ListType;
    this.CustomerId = CustomerId;
    this.fcnumber = FCNumber;
    this.ConsignmentDetailId = ConsignmentDetailId;

    // Added By Pawan Darji on 20/1/2020
    setTimeout(() => {
      //Calling funcion list wise id 'O' then Origin and If 'D' then Destination
      //using ListType For passing can calling Different Functions and parameters    --modified by Pawan Darji on 18-feb 2020
      if (ListType == "D") {
        DashboardComponent.dashboardComponent.DetailComp.GetOrderListByBookingId(
          Id,
          ListType,
          CustomerId
        );
      } else {
        DashboardComponent.dashboardComponent.DetailComp.GetOrderListByBookingId(
          Id,
          ListType,
          null
        );
      }
    }, 200);

    //Calling TimelineDataForBooking Here and Passing Id Form Dashboard.component.html    --modified by pawan darji on 18-feb 2020
    setTimeout(() => {
      DashboardComponent.dashboardComponent.DetailComp.GetTimelineDataForBooking(
        FCNumber,
        ListType,
        Id,
        ConsignmentDetailId
      );
    });
  } // Ends Here

  onShow() {
    this.chatservice.show = true;
    this.chatservice.component.emit({ header: "ORD-12" });
  }

  //Search Bar for Dashbaord module           ------------Created By Pawan Darji on 18-feb-2020
  //Searching Records On FCNumber
  //Start
  onSearch() {
    // Declare variables
    var filter, tr, td, i, txtValue;
    filter = this.search.toUpperCase();
    let getList = document.getElementById("onsearchdashboard");
    let li = getList.getElementsByTagName("li");
    // Loop through all table rows, and hide those who don't match the search query
    for (let i = 0; i < li.length; i++) {
      td = li[i].getElementsByTagName("span")[1];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          li[i].style.display = "";
        } else {
          li[i].style.display = "none";
        }
      }
    }
  }
  //Search Ends Here

  initMap() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const map = new google.maps.Map(document.getElementById("directionMap"), {
      zoom: 6,
      center: { lat: 41.85, lng: -87.65 },
    });
    const image = "../../assets/img/truck.png";
    if(this.service.isDisplayLiveLocation == 1){
      const beachMarker = new google.maps.Marker({
        position: { lat: this.service.TrackLat, lng: this.service.TrackLng },
        map,
        icon: image,
        title: this.vNo,
      });
      const infoWindow = new google.maps.InfoWindow();
      beachMarker.addListener("click", () => {
        beachMarker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          beachMarker.setAnimation(null);
        }, 2000);
        infoWindow.close();
        infoWindow.setContent('<table style="table-layout: fixed;">'+
                                '<tr>'+
                                  '<td style="font-weight: bold">Vehicle No:</td>'+
                                  '<td>'+this.vNo+'</td>'+
                                '</tr>'+
                                '<tr>'+
                                  '<td style="font-weight: bold">Driver:</td>'+
                                  '<td>'+this.fname+' '+this.lname+'</td>'+
                                '</tr>'+
                                '<tr>'+
                                  '<td style="font-weight: bold">Driver Mobile No:</td>'+
                                  '<td>'+this.mob+'</td>'+
                                '</tr>'+
                              '</table>');
        infoWindow.open(beachMarker.getMap(), beachMarker);
      });
    }
    directionsRenderer.setMap(map);
    this.calculateAndDisplayRoute(directionsService, directionsRenderer);
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    directionsService
      .route({
        origin: {
          query: this.service.origin,
        },
        destination: {
          query: this.service.destination,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
      })
      .catch((e) => window.alert("Directions request failed due to " + status));
  }

}
